"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var react_1 = require("react");
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = require("./context");
/**
 * Gallery item
 *
 * Should be a children of Gallery or CustomGallery component
 */
var Item = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    var ref = (0, react_1.useRef)();
    var _b = (0, react_1.useContext)(context_1.Context), remove = _b.remove, set = _b.set, handleClick = _b.handleClick;
    var open = (0, react_1.useCallback)(function () { return handleClick(ref); }, []);
    (0, react_1.useEffect)(function () {
        set(ref, restProps);
        return function () { return remove(ref); };
    }, Object.values(restProps));
    return children({ ref: ref, open: open });
};
exports.Item = Item;
exports.Item.propTypes = {
    original: prop_types_1.default.string,
    thumbnail: prop_types_1.default.string,
    width: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    height: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    title: prop_types_1.default.string,
    html: prop_types_1.default.string,
    children: prop_types_1.default.func.isRequired,
    id: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
};
